import { apiCall } from "../../utilities/apiCall";
import { getSessionValue } from "../../utilities/commonHelpers";
import {
	API_ADMIN_SUBPRODUCTTYPES_GET_ALL,
	API_ADMIN_PRODUCTS_GET_MASTERDATA,
	API_ADMIN_CUSTOMFIELDS_GET_VALUES,
	API_ADMIN_RATECARDS_GET_PRODUCT_BYID,
	API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA,
	API_CRM_CONTACTS_GET_PRODUCTIONCONTACTS,
	API_CRM_CONTACTS_GET_BILLINGCONTACTS,
	API_ADMIN_ISSUES_GET_BYPRODUCTANDDEFAULTYEARS,
	API_ADMIN__RATECARDS_GET_ALL_DETAILS,
	API_USER_ACCOUNTS_GET_MASTERDATA,
	API_CRM_GET_CONTACTDETAILs_CREATE,
	API_ADMIN_RATECARDS_GET_RATESANDCHARGES,
	API_PRODUCTION_ORDERS_GET_BYID,
	API_PRODUCTION_PROPOSALS_INSERTIONS_GET_BYID,
	API_ADMIN_ADJUSTMENTS_GET_BYRATECARD,
	API_ADMIN_PRODUCTS_GET_SIMILAR,
	API_PRODUCTION_ORDERS_SAVE_COPY,
	API_PRODUCTION_PROPOSALS_INSERTIONS_SAVE_COPY,
	API_USER_CONTACTDEFAULTREPFORPROPOSALANDORDER_GET,
	API_PAYMENTPLAN_CUSTOMER_GET,
	API_PAYMENTPLAN_ITEM_ADD,
	API_PAYMENTPLAN_ITEM_DELETE,
	API_PAYMENTPLAN_ACTUALTOTAL_UPDATE,
	API_PRODUCTION_PROPOSALS_GET_BYCUSTOMER,
	API_PRODUCTION_PROPOSALS_BULK_DELETE,
	API_PRODUCTION_PROPOSALS_SAVE,
	API_PRODUCTION_PROPOSALS_GET_ESIGNSTATUS,
	API_ADMIN_SITESETTINGS_GET_CURRENTDATETIME,
	API_ADMIN_MASTERDATA_GET_TAGS,
	API_PRODUCTION_TAGS_REMOVE,
	API_UPDATE_PRODUCTION_FIELDS,
	API_PRODUCTION_CHECK_INVENTORY_LIMIT,
	API_ADMIN_TAXES,
	API_ADMIN_CUSTOMER_TAX_DETAILS,
	API_PRODUCTION_GET_SECURITY,
	API_PRODUCTION_ORDERS_SPLIT,
	API_PRODUCTION_PROPOSALS_INSERTIONS_SPLIT,
	API_PRODUCTION_ORDERS_CREATE_QUICKINVOICES,
	API_SEND_TO_INDESIGN,
	API_ADMIN_RATECARDS_Linked_GET_BYIssueID,
	API_PRODUCTION_ORDERENTRY_ADJUSTMENS_GET, 
	API_GET_CLASSIFIED_STYLES,
	API_PRODUCTION_INVENTORY_LIST,
	API_SELF_SERVICE_PORTAL_RENEW_DETAILS,
	API_SELF_SERVICE_PORTAL_RENEW_CANCEL,
	API_PRODUCTION_ORDERS_GETBASICINFO
} from "../../utilities/apiUrls";

const loggedInUserId = getSessionValue("UserID");

export const getContactDetails = (contactID, orderID) => {
	return apiCall(`${API_CRM_GET_CONTACTDETAILs_CREATE}/${contactID}`);
};
export const getSubProductTypes = (getDisabled = false) => {
	//Domain.mm.com/services/Admin/SubProductTypes/${flag}
	//1 - enabled records
	//0 -  disabled records
	//-1 - all enabled and disabled records
	return apiCall(`${API_ADMIN_SUBPRODUCTTYPES_GET_ALL}/1/false/${getDisabled}`, "GET");
};

//TODO: Need to update this Service to get Similar Products on Order/Insertion Edit
export const getProducts = (subProductId, productID = -1, isActive = 2) => {
	//Domain.mm.com/services/Admin/Products/Master/<SubProductTypeID>/<isSecurityNeeded>/<{productID>/<isActive>
	return apiCall(`${API_ADMIN_PRODUCTS_GET_MASTERDATA}/${subProductId}/${true}/${productID}/${isActive}`, "GET");
};


export const getRateDetails = (rateCardID) => {
	return apiCall(`${API_ADMIN__RATECARDS_GET_ALL_DETAILS}/${rateCardID}`, "GET");
};

export const getCustomFields = () => {
	//Domain.mm.com/services/admin/customfields/values/<IdFieldValue>/<Location>/<userID>/<DeptID>/<isAdmin>/<isEdit>
	const idFieldValue = 1; //pass ID for edit mode
	const location = "Production";
	const isAdmin = getSessionValue("IsAdmin");
	const deptId = 0;
	const isEdit = true;
	return apiCall(
		`${API_ADMIN_CUSTOMFIELDS_GET_VALUES}/${idFieldValue}/${location}/${loggedInUserId}/${deptId}/${isAdmin}/${isEdit}`,
		"GET"
	);
	// return apiCall(`/services/admin/customfields/locations/Production`, "GET");
};
export const getRateCards = (productId, RateCardID,isActive = 1) => {
	//Domain.mm.com/services/admin/Ratecards/Products/<ProductID>/<RateCardID>
	return apiCall(`${API_ADMIN_RATECARDS_GET_PRODUCT_BYID}/${productId}/${RateCardID}/${true}/${isActive}`);
};

export const getProductionContacts = (contactID,ID,proposalid) => {
	//Domain.mm.com/services/crm/contacts/ProductionContacts/<ContactID>
	return apiCall(`${API_CRM_CONTACTS_GET_PRODUCTIONCONTACTS}/${contactID}/${ID <=0 ? 0 : ID}/${proposalid <=0 ? 0 : proposalid}`, "GET");
};
export const getBillingContacts = (contactID,ID,proposalid) => {
	//Domain.mm.com/services/crm/contacts/BillingContacts/<ContactID>
	return apiCall(`${API_CRM_CONTACTS_GET_BILLINGCONTACTS}/${contactID}/${ID <=0 ? 0 : ID}/${proposalid <=0 ? 0 : proposalid}`, "GET");
};

export const getIssues = (productId, IsShowAdditionalInsertionYears = true) => {
	//http://Domain.mm.com/services/admin/issues/products/year/groupbuy/<ProductID>/<GroupID>
	return apiCall(
		`${API_ADMIN_ISSUES_GET_BYPRODUCTANDDEFAULTYEARS}/${productId}/${-1}/${IsShowAdditionalInsertionYears}`,
		"GET"
	);
};
export const getSalesReps = (contactID) => {
	// http://Domain.mm.com/services/User/Accounts/Master/<loginUserID>/<isAddDefaultItem>/<isSecurityNeeded>/<orderID>/<customerID>/<proposalID>/<isAR>/<showInList>

	return apiCall(`${API_USER_ACCOUNTS_GET_MASTERDATA}/${loggedInUserId}/${true}/${true}/${-1}/${contactID}/${-1}`); //orderId,proposalId to be chaged for edit
};

export const getInitialRep = (contactID, proposalID) => {
	return apiCall(`${API_USER_CONTACTDEFAULTREPFORPROPOSALANDORDER_GET}/${contactID}/${proposalID}`);
};

export const getAdSizes = (rateCardID, subProductId, isOnlySelected = 0) => {
	return apiCall(`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductId}/adsizes/${isOnlySelected}`);
};

export const getAdColors = (rateCardID, subProductId, isOnlySelected = 0) => {
	return apiCall(
		`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductId}/adcolors/${isOnlySelected}`
	);
};

export const getAdFrequencies = (rateCardID, subProductID, isOnlySelected = 0) => {
	return apiCall(
		`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductID}/adfrequencies/${isOnlySelected}`
	);
};

export const getAdSections = (rateCardID, subProductID, isOnlySelected = 0) => {
	return apiCall(
		`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductID}/adsections/${isOnlySelected}`
	);
};

export const getAdcolumns = (rateCardID, subProductID, isOnlySelected = 0) => {
	return apiCall(
		`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductID}/adcolumns/${isOnlySelected}`
	);
};

export const getAdInches = (rateCardID, subProductID, isOnlySelected = 0) => {
	return apiCall(`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductID}/adinchs/${isOnlySelected}`);
};

export const getAdPositions = (rateCardID, subProductID, isOnlySelected = 0) => {
	return apiCall(
		`${API_ADMIN_ADMASTERS_GET_ALL_BYCRITERIA}/${rateCardID}/${subProductID}/adpositions/${isOnlySelected}`
	);
};

export const getRatesAndCharges = (rateCardID,multiCurrencyID=-1) => {
	return apiCall(`${API_ADMIN_RATECARDS_GET_RATESANDCHARGES}/${rateCardID}/${multiCurrencyID}`);
};

export const getAllProductionTags = () => {
	return apiCall(`${API_ADMIN_MASTERDATA_GET_TAGS}`);
};

export const removeProductionTag = (reqObj) => {
	return apiCall(API_PRODUCTION_TAGS_REMOVE, "DELETE", reqObj);
};

export const saveOrderField = (reqObj) => {
	return apiCall(API_UPDATE_PRODUCTION_FIELDS, "POST", reqObj);
};

export const saveAndCopyOrders = (saveObj) => {
	// apiCall(API_PRODUCTION_ORDERS_SAVE_COPY, "POST", saveObj)
	return new Promise((resolve, reject) => {
		apiCall(API_PRODUCTION_ORDERS_SAVE_COPY, "POST", saveObj)
			.then((res) => {
				if (res && res.content && res.content.Status === "Success") {
					resolve(res.content);
				} else {
					reject(res);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const saveAndCopyInsertions = (saveObj) => {
	// apiCall(API_PRODUCTION_PROPOSALS_INSERTIONS_SAVE_COPY, "POST", saveObj)
	return new Promise((resolve, reject) => {
		apiCall(API_PRODUCTION_PROPOSALS_INSERTIONS_SAVE_COPY, "POST", saveObj)
			.then((res) => {
				if (res && res.content && res.content.Status === "Success") {
					resolve(res.content);
				} else {
					reject(res);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const createQuickInvoices = (orderQuickPayData) => {
	return apiCall(`${API_PRODUCTION_ORDERS_CREATE_QUICKINVOICES}`, "POST", orderQuickPayData);
}

export const getRepSettings = (id) => {
	return apiCall(`${API_PRODUCTION_GET_SECURITY}/${id}`, "GET");
}

export const checkInvLimit = (invObj) => {
	return apiCall(`${API_PRODUCTION_CHECK_INVENTORY_LIMIT}`, "POST", invObj);
};

export const getOrderDetails = (orderID) => {
	return apiCall(`${API_PRODUCTION_ORDERS_GET_BYID}/${orderID}`, "GET");
};
export const getInsetionDetails = (proposalID, insetionID) => {
	return apiCall(`${API_PRODUCTION_PROPOSALS_INSERTIONS_GET_BYID}/${proposalID}/${insetionID}`, "GET");
};

export const getAdjustmentTypeDetails = (ratecardID) => {
	return apiCall(`${API_ADMIN_ADJUSTMENTS_GET_BYRATECARD}/${ratecardID}`);
};

export const getTaxes = () => {
	return apiCall(`${API_ADMIN_TAXES}`, "GET");
}

export const getTaxGroups = (contactID, orderID, selectedTaxGroupIDs, orderType, productID=0) => {
	return apiCall(`${API_ADMIN_CUSTOMER_TAX_DETAILS}/${contactID}/${orderID}/${orderType}/${productID}`, "POST", selectedTaxGroupIDs);
}

export const getMultipleProducts = (productId, rateCardID) => {
	return apiCall(`${API_ADMIN_PRODUCTS_GET_SIMILAR}/${productId}/${rateCardID}`);
};

export const getPaymentPlans = (contactID) => {
	return apiCall(`${API_PAYMENTPLAN_CUSTOMER_GET}/${contactID}`);
};

export const addOrderToPaymentPlan = (paymentPlanID, orderID) => {
	return apiCall(`${API_PAYMENTPLAN_ITEM_ADD}/${paymentPlanID}/${orderID}/-1`, "POST");
};
export const removePaymentPlanForOrder = (paymentPlanID, orderID) => {
	return apiCall(`${API_PAYMENTPLAN_ITEM_DELETE}/${paymentPlanID}/${orderID}/-1`, "DELETE");
};

export const updatePaymentPlanOrder = (paymentPlanID) => {
	return apiCall(`${API_PAYMENTPLAN_ACTUALTOTAL_UPDATE}/${paymentPlanID}/paymentplan`, "POST");
};

export const proposalList = (contactID, year) => {
	return apiCall(`${API_PRODUCTION_PROPOSALS_GET_BYCUSTOMER}/${contactID}/${year}`, "GET");
};

export const DeleteProposals = (proposalId) => {
	return apiCall(`${API_PRODUCTION_PROPOSALS_BULK_DELETE}`, "Post", proposalId);
};

export const addProposal = (data) => {
	return apiCall(`${API_PRODUCTION_PROPOSALS_SAVE}`, "Post", data);
};

export const getEsignature = (rsID) => {
	return apiCall(`${API_PRODUCTION_PROPOSALS_GET_ESIGNSTATUS}/${rsID}`, "GET");
};

export const getMoveOrderDateTime = (date = true) => {
	return apiCall(`${API_ADMIN_SITESETTINGS_GET_CURRENTDATETIME}/${date}`, "GET");
};

export const splitProposalInsertion=(payloadObj)=>{
	return apiCall(`${API_PRODUCTION_PROPOSALS_INSERTIONS_SPLIT}`,"POST",payloadObj);
}

export const splitOrders = (payloadObj) =>{
	return apiCall(`${API_PRODUCTION_ORDERS_SPLIT}`,"POST",payloadObj);
}

export const sendToIndesign = (indesignDetails)=>{
	return apiCall(`${API_SEND_TO_INDESIGN}`,"POST",indesignDetails);
}

export const getLinkedByIssues = (payloadObj) =>{
	return new Promise((resolve, reject) => {
		apiCall(`${API_ADMIN_RATECARDS_Linked_GET_BYIssueID}`,"POST",payloadObj)
		  .then((res) => {
			if (res?.content?.Status === "Success") {
			  resolve(res.content.List);
			} else {
			  reject(res.Message);
			}
		  })
		  .catch((error) => {
			console.log(error);
			reject(error);
		  });
	  });
}

export const processAdjustments = (payloadObj) => {
	return apiCall(`${API_PRODUCTION_ORDERENTRY_ADJUSTMENS_GET }`,"POST",payloadObj);
}

export const getClassifiedStyles = (searchTerm ="") => {
	return apiCall(`${API_GET_CLASSIFIED_STYLES}${searchTerm?"?query="+searchTerm:""}`, "GET");
}

export const getInventoryList = (payloadObj) => {
	return apiCall(`${API_PRODUCTION_INVENTORY_LIST}`, "POST", payloadObj);
}

export const getRenewalCancelShowCheck = (orderId,RenewAction = 'GetBySourceID') => {
	return apiCall(`${API_SELF_SERVICE_PORTAL_RENEW_DETAILS}/${orderId}/${RenewAction}`, "GET");
}

export const cancelCBMORenewal = (payloadObj) => {
	return apiCall(`${API_SELF_SERVICE_PORTAL_RENEW_CANCEL}`, "POST", payloadObj);
}

export const getOrderBasicInfo = (orderID,proposalid = -1) => {
	return apiCall(`${API_PRODUCTION_ORDERS_GETBASICINFO}/${orderID}/${proposalid}`, "GET");
}
